import httpClient from './httpClient';
import type {
  OwnerDashboard,
  SalesDashboard,
  WarehouseDashboard,
  ServiceDashboard,
} from '@/types/analytics';

export const analyticsApi = {
  async getOwnerDashboard(): Promise<OwnerDashboard> {
    const mdResponse = await httpClient.get<OwnerDashboard>(
      '/analytics/owner-dashboard'
    );
    return mdResponse.data;
  },

  async getSalesDashboard(): Promise<SalesDashboard> {
    const mdResponse = await httpClient.get<SalesDashboard>(
      '/analytics/sales-dashboard'
    );
    return mdResponse.data;
  },

  async getWarehouseDashboard(): Promise<WarehouseDashboard> {
    const mdResponse = await httpClient.get<WarehouseDashboard>(
      '/analytics/warehouse-dashboard'
    );
    return mdResponse.data;
  },

  async getServiceDashboard(): Promise<ServiceDashboard> {
    const mdResponse = await httpClient.get<ServiceDashboard>(
      '/analytics/service-dashboard'
    );
    return mdResponse.data;
  },
};
